var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'separator-border',
    _vm.vertical && 'separator-border--vertical',
    !_vm.vertical && 'separator-border--horizontal',
    _vm.gradient && _vm.gradientClass,
    !_vm.gradient && 'separator-border--solid',
    _vm.color && 'separator-border--color' ],style:(("\n      --widthValue: " + _vm.widthValue + ";\n      --heightValue: " + _vm.heightValue + ";\n      --colorValue: " + _vm.colorValue + ";\n    "))})}
var staticRenderFns = []

export { render, staticRenderFns }